null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala/scala/v2.12.6/src/library/scala/PartialFunction.scala